import { useEffect, useState } from 'react';

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import TeamDocsModule from './team-search-docs';

import avtx from '../media/user.png'

import { SearchUserProfile } from '../services/user-accounts';

export default function TeamSearchModule() {

  const [text, setText] = useState('');
  const [form, setForm] = useState(false);
  const [loading,setLoading]=useState(false);

  const [srch, setSearch] = useState(false);
  const [user, setUser] = useState({});
  const [data, setData] = useState({
    mode: '',
    srch: '',
  })

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.srch !== '' && data.srch.length === 10) 
      setForm(true);
  },[data]);

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
    setSearch(false);
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setSearch(false);
    setLoading(true);
    console.log ({...data})
    
    setUser (( await SearchUserProfile(JSON.stringify({
      body: { srch: '91'+data.srch },
      user: { usid: 'xx', form:'xx' }
    }))).data )

    setLoading(false);
    setSearch(true);
  }

  return (
    <>
      <form onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label small">Mobile Number <span className="text-danger">*</span></label>
          <input 
            type="search"     
            className="form-control height-md"   
            value={data.srch}
            onChange={({ target }) => {handleChange("srch", target.value); setText('');}}
            placeholder="9876540123">
          </input>
        </div>

        <div className="">
          <div className="d-grid">
            <button className={`btn height-md ${ form ? 'btn-primary' : 'btn-light'}`}
              disabled={!form}
            ><small>Search</small>
            </button>
          </div>
        </div>

      </form>


      <div className="py-3">
        <hr></hr>
      </div>

      <p className="lead fw-bold">Search Results</p>
      <div className={loading ? '' : 'd-none'}>
        <p>Please Wait...</p>
      </div>

      <div className={loading ? 'd-none' : srch ? '' : 'd-none'}>

        <div className="rounded-wd border p-3 bg-white d-flex">
          <div className="me-auto">
            <p className="lead fw-bold m-0 p-0">Name: {user.name}</p>
            <p className="m-0 p-0">Mobile: {user.mmid}</p>
            <p className="small m-0 p-0">Status: {user.actv ? 'Active' : 'Inactive'}</p>
          </div>
          <div className="" style={{width:'69px', height:'69px'}}>
            <img src={user.avtr || avtx} alt='...' className="img-fluid rounded" ></img>
          </div>
        </div>

        <ViewSectionName data={'Identity Documents'}/>
        <TeamDocsModule data={user.docs && user.docs.filter(item => item.sort==="idnt")}/>
        
        <ViewSectionName data={'Work Documents'}/>
        <TeamDocsModule data={user.docs && user.docs.filter(item => item.sort==="work")}/>

        <ViewSectionName data={'Academic Documents'}/>
        <TeamDocsModule data={user.docs && user.docs.filter(item => item.sort==="acad")}/>

      </div>

    </>
  )
}